import { AxiosInstance, AxiosResponse } from "axios";
import {
  DocumentApiFactory,
  Fichier,
  IbanBicResource,
  MandatApiFactory,
} from "./swagger";

export interface IApi {
  getDocument(type: "DECLARATIONSINISTRE"): Promise<Fichier>;
  verifyMandat(params: IbanBicResource): Promise<number>;
}

const create = (endpoint: string, axiosClient: AxiosInstance) => {
  const ReferentielApi = DocumentApiFactory({}, endpoint, axiosClient);
  const mandatApi = MandatApiFactory({}, endpoint, axiosClient);

  const getDocument = (type): Promise<Fichier> =>
    new Promise((resolve, reject) => {
      ReferentielApi.getDocument(type)
        .then((response: AxiosResponse<Fichier>) => {
          resolve(response.data);
        })
        .catch((error: any) => reject(error));
    });

  const verifyMandat = (params: IbanBicResource): Promise<number> =>
    new Promise((resolve, reject) => {
      mandatApi
        .postReferentielVerifierSepa(params)
        .then((response: AxiosResponse<void>) => {
          resolve(response.status);
        })
        .catch((error: any) => reject(error));
    });
  return {
    getDocument,
    verifyMandat,
  };
};

export default create;
